/**
 * Created by a2dd on 2016-12-09.
 */
(function($) {
    "use strict";

    $(document).ready(function() {

        /**
         * Load more search results via ajax
         */
        var search = function(type, term, page, callback) {

            $.ajax({

                url: searchparams.ajax_url,
                type: 'GET',
                dataType: 'json',
                data: {
                    action: 'sk_search',
                    type: type,
                    s: term,
                    page: page
                }

            }).done( function(data) {

                data = data[type];
                var items = '';

                var source = $('#searchitem-template-'+type).html();
                var template = Handlebars.compile(source);

                data.posts.forEach(function(item) {
                    items += template(item);
                });

                callback(items, data);

            }).error(function(jqHXR, textStatus, errorThrown) {
                console.log('Error searching', textStatus);
            });

        }

        var currentPage = {};

        $('[data-load-more]').on('click', function(e) {

            var $button = $(this);

            var searchType = $button.data('load-more');

            var $searchContainer = $(this).closest('.search-module');

            var $itemsContainer = $searchContainer.find('ol');
            var $currentCountCountainer = $searchContainer.find('.post-count__count');

            e.preventDefault();

            currentPage[searchType] = parseInt(currentPage[searchType] || searchparams.currentPage);
            var page = currentPage[searchType] += 1;

            search(searchType, searchparams.search_string, page, function(items, result) {

                // Update post count info "Visar x av x"
                var displayedPosts = parseInt($currentCountCountainer.html());
                $currentCountCountainer.html(displayedPosts += result.posts.length);

                // Fade in the new items
                var $items = $(items).hide();
                $itemsContainer.append($items);
                $items.fadeIn();

                // Hide button if we are on last page
                if( result.max_num_pages <= currentPage[searchType]) {
                    $button.hide();
                }

            });

        });

        var pageResult = new Bloodhound({

            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,

            remote: {
                url: ajaxdata.ajax_url + '?action=search_suggestions&type=pages&s=%QUERY',
                wildcard: '%QUERY',
                transform: function(response) {
                    if(!response || !response.pages) return false;
                    return response.pages.posts.slice(0, response.pages.suggestion_count);
                }
            }

        });

        var postResult = new Bloodhound({

            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,

            remote: {
                url: ajaxdata.ajax_url + '?action=search_suggestions&type=posts&s=%QUERY',
                wildcard: '%QUERY',
                transform: function(response) {
                    if(!response || !response.posts) return false;
                    return response.posts.posts.slice(0, 3);
                }
            }

        });

        var eserviceResult = new Bloodhound({

            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,

            remote: {
                url: ajaxdata.ajax_url + '?action=search_suggestions&type=eservices&s=%QUERY',
                wildcard: '%QUERY',
                transform: function(response) {
                    if(!response || !response.eservices) return false;
                    return response.eservices.posts.slice(0, 3);
                }
            }

        });

        var eventResult = new Bloodhound({

            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,

            remote: {
                url: ajaxdata.ajax_url + '?action=search_suggestions&type=events&s=%QUERY',
                wildcard: '%QUERY',
                transform: function(response) {
                    if(!response || !response.events) return false;
                    return response.events.posts.slice(0, 3);
                }
            }

        });
    });

    function findAndHighlightExternalLinks() {
        
        $('.tt-container .tt-suggestion > a').each(function () {
            var $a = $(this);
            var url = $a.attr('href');
            if(url.indexOf('.gavle.se') == -1 && (url.indexOf('http://' == 0) || url.indexOf('https://' == 0))) {

                if($a.find('.material-icons').length) {
                   // Nothing
                }
                else {
                    $a.find('.search-module__item__title').append($('<i class="material-icons">&#xE89E;</i>'));
                }
            }
        });
    }
    
})(jQuery);
